import {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import {AccordionSummary, AccordionDetails, Accordion} from 'assets/jss/Faq';
import backIMG from 'assets/img/back-re.svg';
import {data} from './items';

const FAQ = () => {
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(true);

  const toggleAcordion = (index) => {
    setExpanded((prev) => (prev === index ? null : index));
  };

  return (
    <div style={{paddingBottom: '1.5rem'}}>
      <p style={style.header}>
        <div style={style.backBtn}>
          <img src={backIMG} onClick={() => navigate(-1)} />
        </div>
        سوالات متداول
      </p>
      {data.map((item, index) => (
        <Accordion
          key={item.question}
          sx={{
            background: '#F4F4F4',
            fontSize: '12px',
            lineHeight: '1.2rem',
          }}
          expanded={expanded === index}
          onChange={() => toggleAcordion(index)}>
          <AccordionSummary
            aria-controls={`panel${index}-content`}
            id={`panel${index}-header`}
            sx={{
              background: 'transparent !important',
            }}
            expandIcon={
              <KeyboardArrowDownIcon
                sx={{fontSize: '1rem', color: '#707070'}}
              />
            }>
            <p style={style.summary}>{item.question}</p>
          </AccordionSummary>
          <AccordionDetails sx={style.details}>
            {item.answer}
            <a
              href={item.redirectBlue}
              target='_blank'
              rel='noopener noreferrer'>
              <p style={style.blueText}>{item.blueText}</p>
            </a>
            <a href={item.redirectBlue2} target='_blank'>
              <p style={style.blueText}>{item.blueText2}</p>
            </a>
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
};

export default FAQ;

const style = {
  blueText: {
    color: '#3CC0C3',
    textDecoration: 'underline',
  },
  details: {
    minHeight: '10px !important',
    padding: '0 34px 23px !important',
    color: '#6F4D9F',
    lineHeight: '1.4rem',
    fontWeight: 'bold',
    textAlign: 'justify',
  },
  summary: {
    width: '100%',
    textAlign: 'justify',
    color: '#4D4D4E',
    paddingRight: '5px',
  },
  backBtn: {
    position: 'absolute',
    left: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    background: ' #ffffff',
    border: ' 1px solid #eeeeee',
    boxShadow: '-2px -2px 7px #ffffff, 1px 1px 10px rgba(0, 0, 0, 0.1)',
  },
  header: {
    color: '#6F4D9F',
    fontSize: '16px',
    textAlign: 'justify',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '28px',
    marginTop: '80px',
  },
};
